<script setup>
import { useI18n } from 'vue-i18n'
import { findIndexByParam } from '@/utils/findByParam'
import PreferenceListItem from '@/components/preference/PreferenceListItem.vue'

const props = defineProps({
  lists: Array,
  disabled: Boolean,
  attributes: Object,
})

const { locale } = useI18n()
const emit = defineEmits(['update'])
function updateList(list) {
  const index = findIndexByParam(props.lists, 'id', list.id)
  const lists = [...props.lists]

  lists[index].subscribed = list.value

  emit('update', lists)
}

function getTranslationAttr(list, attr) {
  if (list.translations) {
    let translation = list.translations.filter((translation) => translation.language === locale.value)
    if (translation.length === 1) {
      return translation[0][attr]
    }
  }

  return list[attr]
}
</script>

<template>
  <div :class="attributes?.layout_density !== 'comfortable' ? 'pt-2' : ''">
    <template v-for="list in lists" :key="list.createId || list.id">
      <div v-if="list.type === 'separator'" class="mx-6" :class="attributes?.layout_density === 'comfortable' ? 'mt-2' : ''">
        <p
          v-if="list.label || list.icon"
          class="text-xs uppercase tracking-widest mb-0.5 text-left flex items-center gap-1"
          :class="{
            'font-semibold text-gray-500': !list.text_style || list.text_style === 'bold',
            'font-normal text-gray-500': list.text_style === 'normal',
            'font-normal text-gray-400': list.text_style === 'muted',
          }"
        >
          <span v-if="list.icon" class="material-symbols-outlined text-sm" :style="{ color: list.icon_color || '#6b7280' }">{{ list.icon }}</span>
          {{ list.label }}
        </p>
        <hr
          :class="
            attributes?.layout_density === 'comfortable'
              ? attributes?.template_id === 'stacked_marketer'
                ? 'border-t-2 border-gray-400'
                : 'border-t border-gray-200'
              : 'border-t border-gray-100'
          "
          :style="list.separator_color ? { borderColor: list.separator_color } : {}"
        />
      </div>
      <PreferenceListItem
        v-else
        :id="list.id"
        :name="getTranslationAttr(list, 'name')"
        :description="getTranslationAttr(list, 'description')"
        :translations="list.translations"
        :value="list.subscribed !== undefined ? list.subscribed : list.subscription_default_state"
        :disabled="disabled"
        :icon="list.attrs?.icon"
        :icon-color="list.attrs?.icon_color"
        :attributes="props.attributes"
        @input="updateList"
      />
    </template>
  </div>
</template>
